import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React from 'react';
import classnames from 'classnames';
import '../../../../reset/HtmlA/HtmlA.js';
import '../../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../../reset/HtmlH/HtmlH.js';
import '../../../../reset/HtmlInput/HtmlInput.js';
import '../../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../../reset/HtmlLegend/HtmlLegend.js';
import { HtmlLi } from '../../../../reset/HtmlLi/HtmlLi.js';
import '../../../../reset/HtmlNav/HtmlNav.js';
import '../../../../reset/HtmlOl/HtmlOl.js';
import { HtmlSpan } from '../../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../../reset/HtmlUl/HtmlUl.js';
import '../../../../reset/HtmlTable/HtmlTable.js';
import '../../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../../theme/SpacingProvider/SpacingProvider.js';
import { baseStyles } from './WizardNavigationItem.baseStyles.js';
import { styled } from 'styled-components';
import { IconCheck } from 'suomifi-icons';

var baseClassName = 'fi-wizard-navigation-item';
var defaultClassName = "".concat(baseClassName, "--default");
var currentClassName = "".concat(baseClassName, "--current");
var currentCompletedClassName = "".concat(baseClassName, "--current-completed");
var completedClassName = "".concat(baseClassName, "--completed");
var comingClassName = "".concat(baseClassName, "--coming");
var disabledClassName = "".concat(baseClassName, "--disabled");
var innerWrapperClassName = "".concat(baseClassName, "_inner-wrapper");
var leftIconClassName = "".concat(baseClassName, "_left-icon");
var BaseWizardNavigationItem = function BaseWizardNavigationItem(_a) {
  var _b;
  var className = _a.className,
    children = _a.children,
    status = _a.status,
    passProps = __rest(_a, ["className", "children", "status"]);
  return /*#__PURE__*/React.createElement(HtmlLi, __assign({
    className: classnames(className, baseClassName, (_b = {}, _b[defaultClassName] = status === 'default', _b[currentClassName] = status === 'current', _b[currentCompletedClassName] = status === 'current-completed', _b[completedClassName] = status === 'completed', _b[comingClassName] = status === 'coming', _b[disabledClassName] = status === 'disabled', _b)),
    "aria-disabled": status === 'disabled' ? true : undefined
  }, passProps), /*#__PURE__*/React.createElement(HtmlDiv, {
    className: innerWrapperClassName
  }, /*#__PURE__*/React.createElement(HtmlSpan, {
    className: leftIconClassName
  }, (status === 'completed' || status === 'current-completed') && ( /*#__PURE__*/React.createElement(IconCheck, null))), children));
};
var StyledWizardNavigationItem = styled(function (props) {
  props.theme;
    var passProps = __rest(props, ["theme"]);
  return /*#__PURE__*/React.createElement(BaseWizardNavigationItem, __assign({}, passProps));
}).withConfig({
  componentId: "sc-jfi0a7-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var WizardNavigationItem = function WizardNavigationItem(props) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(StyledWizardNavigationItem, __assign({
      theme: suomifiTheme
    }, props));
  });
};
WizardNavigationItem.displayName = 'WizardNavigationItem';
var templateObject_1;

export { WizardNavigationItem };
//# sourceMappingURL=WizardNavigationItem.js.map
